export default __webpack_public_path__ + "static/media/icon-test-active.dceefaf2.svg";